import { Route, Routes } from "react-router-dom"
import DynamicDropdownList from "./components/DynamicDropdownList"

export default function DynamicDropdownsPage() {
  return (
    <Routes>
      <Route index element={<DynamicDropdownList />} />
      <Route path=":id" element={<DynamicDropdownList />} />
    </Routes>
  )
}
